import { Subject } from "rxjs";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { ManualNettingAction } from "shared/cubiq-model-multi-asset/model/enum/ManualNettingAction";
import { FillOrderData } from "../../model/core/FillOrderData";
import { IOrderDataActionService } from "../IOrderDataActionService";
import { BasePrimaryActionService } from "./BasePrimaryActionService";
import { DetailFillCcyPair } from "./DetailFillCcyPair";

export abstract class OrderDataActionPromiseService
  extends BasePrimaryActionService
  implements IOrderDataActionService
{
  abstract quickFillOrders(
    orderIds: Array<string>,
    stpRequirement: CubiqTS.FillStpRequirement,
  ): Promise<any>;

  abstract cancelOrders(orderIds: Map<string, string[]>, reason: string): Promise<any>;

  abstract reactivateOrders(orderIds: Array<string>, fromDetailFill?: boolean): Promise<any>;

  abstract submitNewOrder(request: CubiqTS.LinkedOrderRequestImpl): Promise<any>;

  abstract submitBmarkOrder(request: CubiqTS.FixingOrderRequestImpl): Promise<any>;

  abstract submitBmarkOrderModify(request: CubiqTS.FixingOrderModificationRequest): Promise<any>;

  abstract submitModifiedOrder(request: CubiqTS.LinkedOrderModificationRequestImpl): Promise<any>;

  abstract submitModifyInfo(request: CubiqTS.LinkedOrderInfoModificationRequestImpl): Promise<any>;

  abstract modifyOrderLock(orderId: string): Promise<any>;

  abstract modifyOrdersUnlock(orderIds: Array<string>): Promise<any>;

  abstract unlockBenchmarks(orderIds: Array<string>): Promise<any>;

  abstract getModelNotificationFailureEventSubject(): Subject<CubiqTS.ConcreteEncodable>;

  abstract lockOrdersForFill(orders: Array<CubiqTS.OrderDataImpl>): Promise<DetailFillCcyPair[]>;

  abstract unlockOrdersFromFill(orderIds: Array<string>): Promise<any>;

  abstract detailFillOrders(fillOrders: Array<FillOrderData>): Promise<Array<any>>;

  abstract releaseOrder(ids: Array<string>, orderType: CubiqTS.OrderType): Promise<void>;

  abstract amendMarkupOrderLock(orderId: string): Promise<any>;

  abstract amendMarkupApproveAction(
    request: CubiqTS.AmendMarkupSalesApprovalRequestImpl,
  ): Promise<any>;

  abstract pauseResumeOrders(request: CubiqTS.OrderPauseResumeRequestImpl): Promise<any>;

  abstract exportOrders(
    orderIds: string[],
    exportMarkup: boolean,
  ): Promise<CubiqTS.OrderExportResponseImpl>;

  abstract toggleInflightInclusionState(
    orderIds: CubiqTS.Long[],
    state: CubiqTS.InflightInclusionState,
  ): Promise<CubiqTS.ToggleInflightStateResult>;

  /**
   * Send a FillNowLock request for the specified order to the server
   * @param orderId
   */
  abstract fillNowLock(orderId: string): Promise<CubiqTS.FillNowLockResponse | CubiqTS.Errors>;

  /**
   * Should user now wish to process with fillNow, send a general unlock
   * @param orderId
   */
  abstract fillNowUnlock(orderIds: string[]): Promise<any>;

  /**
   * Create a fill now request forr the specified order Id
   * @param orderId
   * @param fillAmount Amount to set in the order request - if null, then the entire remaining samount is filled
   */
  abstract fillNow(
    orderId: string,
    fillAmount: CubiqTS.BigNumber,
  ): Promise<CubiqTS.OrderFillNowResponse | CubiqTS.Errors>;

  /**
   * execute a netting operation on the server on specified orders
   * @param netOperation Net/Clear/Disable Netting operation
   * @param orderIds
   */
  abstract netBenchmarkOrders(netOperation: ManualNettingAction, orderIds: string[]): Promise<any>;
}
